import { c as _c } from "react/compiler-runtime";
import React from "react";
const PreviousArrow = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_541_1543)"><path d="M20 40C31.0278 40 40 31.0278 40 20C40 8.97219 31.0278 0 20 0C8.97219 0 0 8.97219 0 20C0 31.0278 8.97219 40 20 40ZM20 2.5C29.6497 2.5 37.5 10.3503 37.5 20C37.5 29.6497 29.6497 37.5 20 37.5C10.3503 37.5 2.5 29.6497 2.5 20C2.5 10.3503 10.3503 2.5 20 2.5ZM11.6162 20.8837C11.1278 20.3953 11.1278 19.6044 11.6162 19.1162L17.8662 12.8662C18.1103 12.6222 18.4303 12.5 18.75 12.5C19.0697 12.5 19.3897 12.6222 19.6338 12.8662C20.1222 13.3547 20.1222 14.1456 19.6338 14.6338L15.5175 18.75L27.5 18.75C28.1903 18.75 28.75 19.3091 28.75 20C28.75 20.6909 28.1903 21.25 27.5 21.25L15.5175 21.25L19.6338 25.3663C20.1222 25.8547 20.1222 26.6456 19.6338 27.1337C19.1453 27.6219 18.3544 27.6222 17.8662 27.1337L11.6162 20.8837Z" fill="#A1A7C4" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">{t0}<defs><clipPath id="clip0_541_1543"><rect width="40" height="40" fill="white" transform="matrix(-1 0 0 -1 40 40)" /></clipPath></defs></svg></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default PreviousArrow;